import { Stack } from '@hover/blueprint';
import { Button } from '@hover/blueprint/brand';
import React from 'react';
import { Link } from 'gatsby';
import ArrowButton from '../../ui/ArrowButton';

const TeamValuesButtons: React.FC = () => (
  <Stack
    width="100%"
    direction={{ base: 'column', tablet: 'row' }}
    justifyContent="center"
    mt={{ base: 400, desktop: 500 }}
    spacing={{ base: 400, tablet: 600 }}
  >
    <ArrowButton
      colorScheme="primary"
      variant="solid"
      to={`${process.env.GATSBY_V2_PREFIX}/careers`}
      as={Link}
    >
      Join Our Team
    </ArrowButton>
    <Button
      as={Link}
      to={`${process.env.GATSBY_V2_PREFIX}/how-it-works`}
      variant="outline"
      colorScheme="primary"
      px="400"
    >
      Learn More
    </Button>
  </Stack>
);

export default TeamValuesButtons;
